import "core-js/modules/es.array.concat";
import "core-js/modules/es.parse-float";
import "core-js/modules/es.string.pad-start";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadDeviceSetup),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doSubmitUserInformation),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLoadDeviceSetup);

import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { createFormAction } from 'redux-form-saga';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { userProfile } from 'redux/saga/entities/bound';
import { errorActionCreator } from 'redux/saga/helpers';
import { updateDevice } from 'redux/modules/video';
import BLUETOOTH_STATUS from 'constants/bluetooth';
export var LOAD_DEVICE_SETUP = 'LOAD_DEVICE_SETUP';
export var LOAD_DEVICE_ERROR = 'LOAD_DEVICE_ERROR';
export var loadDeviceSetup = function loadDeviceSetup() {
  return {
    type: LOAD_DEVICE_SETUP
  };
};
export var submitUserInformation = createFormAction('updateLiveProfile');
export var loadDeviceError = errorActionCreator.bind(null, LOAD_DEVICE_ERROR);
export function doLoadDeviceSetup(client) {
  return regeneratorRuntime.wrap(function doLoadDeviceSetup$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 3:
          _context.next = 9;
          break;

        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          _context.next = 9;
          return put(loadDeviceError(_context.t0));

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 5]]);
}
export function doSubmitUserInformation(client, _ref) {
  var _ref$payload, gender, birthDateMonth, birthDateDay, birthDateYear, weight, tagline, data, nextStatus, dateOfBirth;

  return regeneratorRuntime.wrap(function doSubmitUserInformation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref$payload = _ref.payload, gender = _ref$payload.gender, birthDateMonth = _ref$payload.birthDateMonth, birthDateDay = _ref$payload.birthDateDay, birthDateYear = _ref$payload.birthDateYear, weight = _ref$payload.weight, tagline = _ref$payload.tagline;
          _context2.prev = 1;

          if (typeof tagline !== 'undefined') {
            nextStatus = BLUETOOTH_STATUS.PREPARE_WEARABLE;
            data = {
              tagline: tagline
            };
          } else {
            nextStatus = BLUETOOTH_STATUS.INPUT_TAGLINE;
            dateOfBirth = "".concat(birthDateYear, "-").concat(String(birthDateMonth).padStart(2, '0'), "-").concat(String(birthDateDay).padStart(2, '0'));
            data = {
              gender: gender,
              date_of_birth: dateOfBirth,
              weight: {
                lb: parseFloat(weight)
              }
            };
          }

          _context2.next = 5;
          return call(client.users.updateUserProfile, data);

        case 5:
          _context2.next = 7;
          return all([put(submitUserInformation.success()), put(updateDevice({
            status: nextStatus
          }))]);

        case 7:
          _context2.next = 9;
          return call(fetchEntity, userProfile, [client]);

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return put(loadDeviceError(_context2.t0));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}
export function watchLoadDeviceSetup(client) {
  return regeneratorRuntime.wrap(function watchLoadDeviceSetup$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, LOAD_DEVICE_SETUP, doLoadDeviceSetup, client);

        case 2:
          _context3.next = 4;
          return fork(takeEvery, submitUserInformation.REQUEST, doSubmitUserInformation, client);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}